import { render, staticRenderFns } from "./Balances.vue?vue&type=template&id=0160b884&scoped=true&"
import script from "./Balances.vue?vue&type=script&lang=ts&setup=true&"
export * from "./Balances.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./Balances.vue?vue&type=style&index=0&id=0160b884&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0160b884",
  null
  
)

export default component.exports